/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var QuoteDraftAction;

(function (QuoteDraftAction) {
  QuoteDraftAction["RENEW"] = "renew";
  QuoteDraftAction["UPDATE"] = "update";
  QuoteDraftAction["CANCEL"] = "cancel";
})(QuoteDraftAction || (QuoteDraftAction = {}));